import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { Container, Col, Label, Button } from "reactstrap";

const ConfirmationPopup = (props) => {
  const market = props.market;
  const searchName = props.searchName;
  const [name, setName] = useState("");
  const [open, setOpen] = useState(props.open);
  const [snack, setSnackOpen] = useState({ snackOpen: false, snackMsg: "" });
  const [ErrMsg_Name, setErrMsg_Name] = useState(false);

  useEffect(() => {
    if (props.title === 2) {
      let marketName = market && market !== null && market.marketName ? market.marketName : "";
      setName(marketName);
    }
    if (props.title === 1) {
      let name = searchName && searchName !== null ? searchName : "";
      setName(name);
    }
  }, [props])

  const handleSubmit = () => {
    if (name === "") {
      setErrMsg_Name(true);
      setOpen(true);
    }else {
      setErrMsg_Name(false);
      setOpen(false);
      if (props.title === 1) {
        // passing 1 indicates show snackbar
        props.togglePopup(false, '1', name);
      }
      if (props.title === 2) {
        // passing 1 indicates show snackbar
        props.togglePopup(false, '2');
      }
    }
  }

  const handleClose = () => {
    setOpen(false);
    setErrMsg_Name(false);
    // passing 0 indicates not to show snackbar
    props.togglePopup(false, '0');
  }
  const handleEnter = (event) => {
    if (event.keyCode == 13) {
      handleSubmit();
    }
  }

  return (
    <div>
      {open ? <div>
        <div className={props.title === 1 ? "editmarketname save-search-box" : "editmarketname"}>
          <TextField id="outlined-basic" label="Name" variant="outlined" value={name} autoComplete="off"
            onChange={(e) => setName(e.target.value)}
            onKeyDown={handleEnter} className="textbox-custom" />

          <p className="error-msg">{ErrMsg_Name ? "Name is required" : ""}</p>
          <div className="wizard-btns">
            <Button
              onClick={handleClose}
              className="save-close cancel-no-color float-start me-0 "
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              id=""
              className="next-btn float-start ms-2"
            >
              {props.title === 1 ? "Save" : "Update"}
            </Button>
            <div className="clear"></div>
          </div>
          {" "}
        </div>
      </div> : ""}
    </div>
  );
}
export default ConfirmationPopup;
